import { useRef } from "react";
import { Box, Grid2 as Grid } from "@mui/material";
import ItemCard from "./ItemCard";
import { GridConteiner } from "./GridLayout.styles";
import ScrollTop from "../../ScrollTop/ScrollTop";

interface GridProps {
  items: any[] | undefined;
  loading: boolean;
  handleScroll: any;
}

const GridLayout = (props: GridProps) => {
  const scrollRef: any = useRef(null);

  return (
    <GridConteiner
      container
      spacing={0}
      ref={scrollRef}
      onScroll={props.handleScroll}
    >
      {props.loading
        ? [1, 1, 1, 1, 1, 1, 1, 1, 1, 1].map((item, mapIndex) => (
          <Grid key={"row_fake_" + mapIndex}>
            <Box>
              <ItemCard></ItemCard>
            </Box>
          </Grid>
        ))
        : props.items &&
        props.items.map((item, mapIndex) => (
          <Grid key={item.code + "_" + mapIndex}>
            <Box>
              <ItemCard
                itemObj={item}
              ></ItemCard>
            </Box>
          </Grid>
        ))}
      <ScrollTop scrollItemRef={scrollRef} />
    </GridConteiner>
  );
};

export default GridLayout;
